"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.1.5'] && _();
}
catch (e) { }
